import { formatMoney } from "_assets/js/helpers";
import moment from "moment";
import {
  IconMichelinStar,
  IconCreditCard,
  IconBuildingBank,
  IconCoins,
  IconCalendarWeek,
  IconCash,
  IconClock,
  IconCreditCardFilled,
} from "@tabler/icons-react";
import { Paragraph } from "_styleguide";

export const reviewData = {
  planName: "Accelerated",
  creditLinesEnrolled: 5,
  creditors: ["Chase", "Wells Fargo", "Bank of America", "Capital One"].join(
    ", "
  ),
  debtEnrolledTotal: formatMoney(22000),
  startDate: moment(parseInt("1728397010968")).format("ddd, MMMM D, YYYY"),
  paymentAmount: `${formatMoney(348)} / Monthly`,
  planDuration: "18 months",
};

const reviewItems = {
  planName: { title: "Relief Plan", icon: <IconMichelinStar /> },
  creditLinesEnrolled: {
    title: "Accounts enrolled",
    icon: <IconCreditCard />,
  },
  creditors: { title: "Creditors Involved", icon: <IconBuildingBank /> },
  debtEnrolledTotal: { title: "Total Debt Enrolled", icon: <IconCoins /> },
  startDate: { title: "Plan Start Date", icon: <IconCalendarWeek /> },
  paymentAmount: { title: "Payment", icon: <IconCash /> },
  planDuration: { title: "Debt Free Time Frame", icon: <IconClock /> },
  bankAccount: { title: "Bank Account", icon: <IconBuildingBank /> },
  cardAccount: { title: "Credit/Debit Card", icon: <IconCreditCardFilled /> },
};

export const getReviewItem = (item, data) => {
  const { title, icon } = reviewItems[item];
  return (
    <div key={"review-item-" + item} className="review-item">
      <Paragraph>
        {icon}
        {title}
      </Paragraph>
      <Paragraph>{data}</Paragraph>
    </div>
  );
};
